<template>
    <div class="create-user">
        
        <div class="title is-3">Criar minha conta</div>
        
        <form @submit.prevent="create">
            <b-field label="Nome">
                <b-input
                    v-model="userData.name"
                    type="text"
                    placeholder="Informe o seu nome"
                    required
                />
            </b-field>
            <b-field label="E-mail">
                <b-input
                    v-model="userData.email"
                    type="email"
                    placeholder="Informe o seu e-mail"
                    required
                />
            </b-field>
            <b-field label="Telefone de Contato">
                <b-input
                    v-model="userData.phone"
                    placeholder="Informe o seu telefone, telegram ou whatsapp"
                />
            </b-field>
            <b-field
                label="Senha"
                message="A senha deve conter no mínimo 6 caracteres"
            >
                <b-input
                    v-model="userData.password"
                    type="password"
                    placeholder="Informe uma senha"
                    minlength="6"
                    required
                />
            </b-field>

            <button
                type="submit"
                class="button is-primary is-rounded is-fullwidth is-large"
            >
                Criar minha conta
            </button>
        </form>
    </div>
</template>

<script>
    import auth from "@/services/auth";
    import functions from '@/services/functions';

    export default {
        name: "auth-user-create",

        data() {
            return {
                userData: {
                    name: null,
                    email: null,
                    phone: null,
                    password: null
                }
            };
        },

        methods: {
            async create() {
                const loading = this.$buefy.loading.open();
                const {email, password, name, phone} = this.userData;

                try {
                    const response = await auth.createUserWithEmailAndPassword(email, password);

                    const user = response.user;
                    await user.updateProfile({
                        displayName: name
                    });
                    
                    const createUser = functions.httpsCallable('createUser');
                    await createUser({email, name, phone});

                } catch (e) {

                    const errors = {
                        'unknown': 'Ocorreu um erro desconhecido, por favor tente novamente mais tarde',
                        'auth/email-already-in-use': 'O e-mail informado já está em uso, por favor informe outro e-mail ou acesse sua conta'
                    }

                    const errorCode = e.code || 'unknown';
                    const message = errors[errorCode] || errors['unknown'];

                    this.$buefy.toast.open({
                        type: "is-danger",
                        message
                    });

                }
                
                loading.close();
            }
        }
    };
</script>
